import React, { useEffect, useRef } from 'react';
import { SupportedPaymentMethods } from '../../services/ApplicationSession';
import { useTheme } from 'styled-components';
var GooglePay = function (props) {
    var googlePayRef = useRef(null);
    var googlePayInputForm = useRef(null);
    var theme = useTheme();
    var callback = function (authResponse) {
        if (authResponse.isValid) {
            googlePayInputForm.current = {
                paymentType: SupportedPaymentMethods.WEB_DROP_IN_GOOGLE_PAY,
                encryptedCustomerInput: authResponse.data.paymentMethod,
                browserInfo: authResponse.data.browserInfo,
                riskData: authResponse.data.riskData
            };
            return;
        }
    };
    var onAuthorizedCallback = function (additionalData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        console.log('onAuthorizedCallback: ', additionalData);
        // update billingAddress in session config to return on onSuccess callback
        var paymentMethodData = additionalData.paymentMethodData;
        var firstName, lastName;
        if ((_b = (_a = paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.info) === null || _a === void 0 ? void 0 : _a.billingAddress) === null || _b === void 0 ? void 0 : _b.name) {
            var name_1 = paymentMethodData.info.billingAddress.name;
            var nameArr = name_1.split(' ');
            lastName = nameArr.pop(); // always treat the last item as lastname
            firstName = nameArr.join(' '); // then the remaining will be the first
        }
        var billingInformation = {
            address: {
                address1: (_d = (_c = paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.info) === null || _c === void 0 ? void 0 : _c.billingAddress) === null || _d === void 0 ? void 0 : _d.address1,
                address2: (_f = (_e = paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.info) === null || _e === void 0 ? void 0 : _e.billingAddress) === null || _f === void 0 ? void 0 : _f.address2,
                stateOrProvince: (_h = (_g = paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.info) === null || _g === void 0 ? void 0 : _g.billingAddress) === null || _h === void 0 ? void 0 : _h.administrativeArea,
                postalCode: (_k = (_j = paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.info) === null || _j === void 0 ? void 0 : _j.billingAddress) === null || _k === void 0 ? void 0 : _k.postalCode,
                city: (_m = (_l = paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.info) === null || _l === void 0 ? void 0 : _l.billingAddress) === null || _m === void 0 ? void 0 : _m.locality
            },
            contact: {
                email: additionalData.email,
                firstName: firstName,
                lastName: lastName
            }
        };
        props.applicationSession.config.billingInformation = billingInformation;
        if (googlePayInputForm.current) {
            googlePayInputForm.current.billingInformation = billingInformation;
            (_o = props === null || props === void 0 ? void 0 : props.onAuthorized) === null || _o === void 0 ? void 0 : _o.call(props, googlePayInputForm.current, undefined);
        }
        return;
    };
    useEffect(function () {
        props.applicationSession.initializeGooglePay(googlePayRef, theme.googlePayButtonColor, callback, props.onProcessing, onAuthorizedCallback, props.isGooglePayAvailable);
    }, [googlePayRef, theme.googlePayButtonColor]);
    return React.createElement("div", { ref: googlePayRef, id: 'googlepay-container' });
};
export default GooglePay;
